// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"5a84dd41","240":"e48d9417","455":"5ec2ff9c","480":"66168aa6","485":"793a0d4a","547":"be3cc992","743":"25898d32","761":"a09bfcfd","787":"70fa4aeb","928":"79074af1"}[chunkId] + ".chunk.js";
};